import styled from 'styled-components'

type Props = {
  primary?: boolean
}

const styledComponent = styled.div<Props>`
  width: ${p => (p.primary ? '100%' : 'auto')};
  flex: ${p => (p.primary ? '0 1 auto' : '0 0 auto')};
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
  overflow: ${p => (p.primary ? 'hidden' : 'visible')};
`

styledComponent.displayName = 'ItemRendererColumn'
export default styledComponent
